import styles from '../../styles/components/Controls.module.scss';

export const ButtonsUpDown = () => {
	return (
		<>
			<button disabled={true} className={styles.up}><span>Up</span></button>
			<button disabled={true} className={styles.down}><span>Down</span></button>
		</>
	);
}